"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayClickArea = void 0;
const tslib_1 = require("tslib");
const GameplayRenderer_1 = require("../GameplayRenderer");
const phaser_1 = tslib_1.__importDefault(require("phaser"));
const consts_1 = require("../consts");
const GameplayUtils_1 = require("./GameplayUtils");
class GameplayClickArea extends phaser_1.default.GameObjects.Container {
    constructor(scene) {
        super(scene);
        this.movedFromTopPercentage = 0.15;
        this.isEnabled = false;
        this.clickCallback = undefined;
        this.clickableRectangle = undefined;
        this.isClickedDown = false;
        this.canvasWidth = this.scene.cameras.main.width;
        this.canvasHeight = this.scene.cameras.main.height;
        this.clickableAreaWidth = this.canvasWidth;
        this.clickableAreaHeight = this.canvasHeight * (1 - this.movedFromTopPercentage);
        this.handleRectangleClick = this.handleRectangleClick.bind(this);
        this.handleRectangleClickDown = this.handleRectangleClickDown.bind(this);
        this.y = this.movedFromTopPercentage * this.canvasHeight;
        this.createClickableRectangle();
    }
    destroy() {
        this.destroyClickRectangle();
        super.destroy();
    }
    destroyClickRectangle() {
        if (this.clickableRectangle) {
            this.clickableRectangle.off(phaser_1.default.Input.Events.POINTER_DOWN);
            this.clickableRectangle.off(phaser_1.default.Input.Events.POINTER_UP);
            this.clickableRectangle.removeInteractive();
            this.clickableRectangle.destroy();
        }
    }
    setClickCallback(clickCallback) {
        this.clickCallback = clickCallback;
    }
    handleRectangleClick(e = undefined) {
        if (!GameplayRenderer_1.GameplayRenderer.mouseEventsEnabled && (e === null || e === void 0 ? void 0 : e.event) instanceof MouseEvent) {
            return;
        }
        // prevent handle click if not clicked down first
        if (!this.isClickedDown) {
            return;
        }
        const isCheckEnabled = GameplayRenderer_1.GameplayRenderer.isCheckingHtmlOnTopBeforeclick;
        const isClickOnCanvas = (0, GameplayUtils_1.checkIfClickedOnCanvas)(e === null || e === void 0 ? void 0 : e.downElement, isCheckEnabled);
        this.isClickedDown = false;
        if (!isClickOnCanvas) {
            return;
        }
        if (!this.clickCallback) {
            return;
        }
        let side = consts_1.SIDE.CENTER;
        if (e) {
            side = (e.worldX < this.canvasWidth / 2)
                ? consts_1.SIDE.LEFT
                : consts_1.SIDE.RIGHT;
        }
        this.clickCallback(side);
    }
    handleRectangleClickDown() {
        this.isClickedDown = true;
    }
    createClickableRectangle() {
        if (this.clickableRectangle) {
            this.destroyClickRectangle();
        }
        this.rectangleShape = new phaser_1.default.Geom.Rectangle(0, 0, this.clickableAreaWidth, this.clickableAreaHeight);
        this.clickableRectangle = new phaser_1.default.GameObjects.Graphics(this.scene);
        this.clickableRectangle.fillStyle(0x00FF00, 0);
        this.clickableRectangle.fillRectShape(this.rectangleShape);
        // this.clickableRectangle.y = this.canvasHeight * this.movedFromTopPercentage;
        this.add(this.clickableRectangle);
        this.clickableRectangle.setInteractive(this.rectangleShape, phaser_1.default.Geom.Rectangle.Contains);
    }
    disableClickArea() {
        var _a, _b;
        if (!this.isEnabled) {
            return;
        }
        this.isEnabled = false;
        (_a = this.clickableRectangle) === null || _a === void 0 ? void 0 : _a.off(phaser_1.default.Input.Events.POINTER_DOWN);
        (_b = this.clickableRectangle) === null || _b === void 0 ? void 0 : _b.off(phaser_1.default.Input.Events.POINTER_UP);
    }
    enableClickArea() {
        var _a, _b;
        // check if already turned on
        if (this.isEnabled) {
            return;
        }
        this.isEnabled = true;
        (_a = this.clickableRectangle) === null || _a === void 0 ? void 0 : _a.on(phaser_1.default.Input.Events.POINTER_DOWN, this.handleRectangleClickDown);
        (_b = this.clickableRectangle) === null || _b === void 0 ? void 0 : _b.on(phaser_1.default.Input.Events.POINTER_UP, this.handleRectangleClick);
    }
    setEnabled(isEnabled) {
        if (isEnabled) {
            this.enableClickArea();
        }
        else {
            this.disableClickArea();
        }
    }
}
exports.GameplayClickArea = GameplayClickArea;
